import * as React from "react";

const pageComponent = React.memo(function Page() {
  return <>TODO</>;
});

export default pageComponent;
